export const FETCH_USER_GROUPS_REQUEST = 'USER_GROUPS/FETCH_REQUEST';
export const FETCH_USER_GROUPS_SUCCESS = 'USER_GROUPS/FETCH_SUCCESS';
export const FETCH_USER_GROUPS_FAILURE = 'USER_GROUPS/FETCH_FAILURE';

export const FETCH_SELECTED_USER_GROUPS_REQUEST = 'USER_GROUPS/FETCH_BY_DEALERS_REQUEST';
export const FETCH_SELECTED_USER_GROUPS_SUCCESS = 'USER_GROUPS/FETCH_BY_DEALERS_SUCCESS';
export const FETCH_SELECTED_USER_GROUPS_FAILURE = 'USER_GROUPS/FETCH_BY_DEALERS_FAILURE';
export const CLEAR_USER_GROUP_SELECT = 'USER_GROUPS/CLEAR_SELECT';

export const UPDATE_USER_GROUPS_REQUEST = 'USER_GROUPS/UPDATE_REQUEST';
export const UPDATE_USER_GROUPS_SUCCESS = 'USER_GROUPS/UPDATE_SUCCESS';
export const UPDATE_USER_GROUPS_FAILURE = 'USER_GROUPS/UPDATE_FAILURE';
